angular.module('components.SessionTimer', [
  'components.sessionTimer.SessionTimerController'
])

/**
 * The SessionTimer directive works with the session to provide
 * the user feedback about when their session will end. Allows
 * for "clicking to keep session alive"
 *
 * @class session-timer
 * @constructor
 * @module components.editor
 * @example
 *   <body session-timer>
 */
.directive('sessionTimer', [
  function () {
    'use strict';

    return {
      restrict: 'A',
      controller: 'SessionTimerController'
    };
  }
]);
